import { render, staticRenderFns } from "./Pos_bill_sale.vue?vue&type=template&id=c86d0a60&scoped=true&"
import script from "./Pos_bill_sale.vue?vue&type=script&lang=js&"
export * from "./Pos_bill_sale.vue?vue&type=script&lang=js&"
import style0 from "./Pos_bill_sale.vue?vue&type=style&index=0&id=c86d0a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86d0a60",
  null
  
)

export default component.exports